/* eslint-disable */
import { getSheduleDrivers } from '@/requests/shedule'
import globalMixin from '@/mixin/global'
import Api from '@/repository/index'
import { Message } from 'element-ui'
import {
  errorResponseMessage,
  showDefaultErrorMessage
} from '@/utils/createMessage'
import { SET_DRIVERS_IN_CHANGE } from './constants'
import * as helpers from '@/store/modules/schedule/helpers'
import timeMixin from '@/mixin/getTimeMixin'

const { getThisWeekDate, getThisWeekDate2 } = timeMixin.methods

export const actions = {
  async transplantDriver ({ dispatch, state }, data) {
    try {
      const { change, date, car_id: carId, driver_id: driverId, current_schedule_id: currentScheduleId } = data
      const { responseState, schedule } = await Api.schedule.index.transplantDriverOtherCar({ change, date, carId, driverId, currentScheduleId })
      const { success, message } = responseState
      if (!success) {
        return Message({
          message: message || 'Ошибка',
          type: 'success',
          duration: 5 * 1000
        })
      }
      const week = state.currentWeek
      const startDate = week[0]
      const endDate = week[week.length - 1]
      await dispatch(
        'worker/updateScheduleTask', { scheduleId: schedule.id, date: schedule.date }, { root: true }
      )

      await dispatch('fetchSchedule', {
        startDate,
        endDate
      })

      await Message({
        message: 'Водитель был перенесен',
        type: 'success',
        duration: 5 * 1000
      })

      return [schedule.id]
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },
  async fetchStatistic ({ commit, state }, { start_date, end_date }) {
    try {
      const StatisticShanges = await Api.schedule.statistic.getStatistic({
        startDate: globalMixin.methods.getUtcFromDate(start_date),
        endDate: globalMixin.methods.getUtcFromDate(end_date),
        regionParkId: state.currentRegionParkID
      })
      commit('SET_CHANGES', StatisticShanges)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },
  async fetchSchedule ({ commit, state }, { startDate, endDate, isWorking }) {
    try {
      commit('TOOGLE_LOADING', true)

      if (!startDate || !endDate) {
        const week = state.currentWeek

        startDate = week[0] || ''
        endDate = week[week.length - 1] || ''
      } else {
        const dates = helpers.getDatesInRange(startDate, endDate)
        commit('SET_CURRENT_WEEK', dates)
      }

      const scheduleParams = {
        startDate: globalMixin.methods.getUtcFromDate(startDate),
        endDate: globalMixin.methods.getUtcFromDate(endDate),
        regionParkId: state.currentRegionParkID,
        carModel: state.scheduleFilters.carModel,
        carCallsign: state.scheduleFilters.carCallsign,
        carNumber: state.scheduleFilters.carNumber,
        driverId: state.scheduleFilters.driverId,
        sortCarBrand: state.scheduleFilters.sortCarBrand,
        sortShiftCount: state.scheduleFilters.sortShiftCount,
        offset: state.scheduleFilters.offset,
        limit: state.scheduleFilters.limit,
        isWorking: isWorking
      }

      const nonEmptyParams = {}
      for (const key in scheduleParams) {
        if (scheduleParams[key] !== null && scheduleParams[key] !== undefined && scheduleParams[key] !== '') {
          nonEmptyParams[key] = scheduleParams[key];
        }
      }

      const schedule = await Api.schedule.index.getSchedule(nonEmptyParams)

      commit('SET_SHEDULE', schedule)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit('TOOGLE_LOADING', false)
    }
  },

  async fetchScheduleByFilters ({ state, dispatch }) {
    try {
      const { dateTime } = state.filter
      const { start, end } = getThisWeekDate2()

      const startOptions = dateTime && dateTime.length > 0 ? dateTime[0] : start
      const endOptions = dateTime && dateTime.length > 0 ? dateTime[1] : end

      await dispatch('fetchSchedule', {
        startDate: startOptions,
        endDate: endOptions
      })
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async fetchCurrentSchedule ({ commit }, id) {
    try {
      const responce = await Api.schedule.index.getScheduleRecordInfo(id)
      commit('SET_CURRENT_SCHEDULE_INFO', responce)
      return responce
    } catch (e) {
      showDefaultErrorMessage()
      return Promise.reject(e)
    }
  },

  async setCurrDriverPagination ({ commit }, { offset, limit }) {
    try {
      commit('SET_PAGINATION_DRIVER', { offset, limit })
    } catch (e) {
      showDefaultErrorMessage()
      return Promise.reject(e)
    }
  },
  async getScheduleDrivers ({ commit, state }, data) {
    try {
      if (data?.search) {
        commit('SET_PAGINATION_DRIVER', { offset: 0 })
      }
      let { timesDay, date } = state.currentSchedule
      const { offset, limit } = state.currentSchedulePagination
      if (timesDay === 'day') {
        timesDay = 'morning'
      }

      const drivers_response = await Api.schedule.index.getScheduleDrivers({
        change: timesDay,
        date,
        offset,
        limit,
        ...data
      })
      commit('SET_PAGINATION_DRIVER', { total: drivers_response.total })
      commit('SET_AVALIABLE_DRIVERS', drivers_response.scheduleDrivers)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async fetchAvailableDrivers ({ commit }, { timesDay, date }) {
    try {
      if (timesDay === 'day') {
        timesDay = 'morning'
      }
      const drivers = await getSheduleDrivers(timesDay, date)

      commit('SET_AVALIABLE_DRIVERS', drivers)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async addDriverSchedule ({ commit, state, dispatch }, data) {
    try {
      commit('TOOGLE_LOADING', true)
      const { scheduleRecords } = await Api.schedule.index.сreateScheduleRecord(
        { scheduleRecords: data }
      )
      Message({
        message: 'Расписание было изменено',
        type: 'success',
        duration: 5 * 1000
      })

      const week = state.currentWeek
      const startDate = week[0]
      const endDate = week[week.length - 1]

      await dispatch('fetchSchedule', {
        startDate,
        endDate
      })

      for (let index = 0; index < scheduleRecords.length; index++) {
        const { scheduleId, date } = scheduleRecords[index]
        setTimeout(() => {
          Promise.all([
            dispatch(
              'worker/updateScheduleTask',
              { scheduleId, date },
              { root: true }
            )
          ])
        }, 500)
      }

      // if (state.currentSchedule.remindDownloadWaybill) {
      return scheduleRecords.map(r => r.scheduleId)
      // }
    } catch (e) {
      await errorResponseMessage(e.response.data)
      return Promise.reject(e)
    } finally {
      commit('TOOGLE_LOADING', false)
    }
  },

  async changeDriverFromSchedule ({ commit, state, dispatch }, { data, id }) {
    try {
      const week = state.currentWeek
      await Api.schedule.index.editScheduleRecord({ scheduleRecords: data })

      await Message({
        message: 'Водитель был изменен в этой смене',
        type: 'success',
        duration: 5 * 1000
      })

      await dispatch('fetchSchedule', {
        startDate: week[0],
        endDate: week[week.length - 1]
      })

      return data.map(r => r.scheduleId)
    } catch (e) {
      // await errorResponseMessage(e.response.data)
      await errorResponseMessage(e.response.data)
      return Promise.reject(e)
    } finally {
      commit('TOOGLE_LOADING', false)
    }
  },

  async fetchRatings ({ commit }, id) {
    try {
      const ratings = await Api.parkManager.rating.getDriverRating({
        driverId: id
      })

      commit('SET_RATINGS', ratings)

      return ratings
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async useTransferRegionPark ({ commit }, dto) {
    try {
      const ratings = await Api.parkManager.cars.useTransferRegionPark(dto)

      Message({
        message: 'Успешно',
        type: 'success',
        duration: 5 * 1000
      })

      return ratings
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },
  async getWaybillTemplatePrint ({ commit }) {
    try {
      const responce = await Api.contracts.waybill.getWaybillTemplatePrint()

      function downloadURI (uri, name) {
        const link = document.createElement('a')
        link.setAttribute('download', name)
        link.href = uri
        document.body.appendChild(link)
        link.click()
        link.remove()
      }

      // Декодируем строку base64 в бинарные данные
      const binaryData = atob(responce?.template)

      // Создаем массив байт из бинарных данных
      const byteArray = new Uint8Array(binaryData.length)
      for (let i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i)
      }

      // Создаем объект Blob из массива байт
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })

      // Создаем URL-адрес объекта Blob
      const blobUrl = URL.createObjectURL(blob)
      downloadURI(blobUrl, 'Шаблон путевого листа.docx')
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async changeDriverRating ({ commit, dispatch }, data) {
    try {
      const responce = await Api.parkManager.rating.createDriverRating({
        driverRating: data
      })
      Message({
        message: 'Оценка была внесена в систему',
        type: 'success',
        duration: 5 * 1000
      })

      dispatch('fetchRatings', data.driverId)

      return responce
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async fetchScheduleReportExelData (_, dto) {
    try {
      console.log(dto)
      const {
        fromDate: startDate,
        toDate: endDate,
        separator,
        region_park_id: regionParkId
      } = dto
      const responce = await Api.schedule.statistic.getStatisticExel({
        startDate: globalMixin.methods.getUtcFromDate(startDate),
        endDate: globalMixin.methods.getUtcFromDate(endDate),
        separator,
        regionParkId
      })
      return responce
    } catch (err) {
      return Promise.reject(err)
    }
  },
  removeScheduleByCarId ({ commit }, car_id) {
    commit('REMOVE_SCHEDULE_BY_CAR_ID', car_id)
  },

  async removeSomeSchedule ({ state, dispatch }, params) {
    try {
      const response = await Api.schedule.index.deleteSomeSchedule(params)

      if (!response.responseState.success) {
        return Message({
          message: response.responseState.message || 'У смены есть транзакции',
          type: 'error',
          duration: 5 * 1000
        })
      }

      const week = state.currentWeek
      const startDate = week[0]
      const endDate = week[week.length - 1]

      await dispatch('fetchSchedule', {
        startDate,
        endDate
      })
      Message({
        message: 'Водитель был снят со смены',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      console.dir(err)
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },

  setCurrentRegionParkID ({ commit }, region_park_id) {
    commit('SET_CURRENT_REGION_PARK_ID', region_park_id)
  },

  setCurrentRegionParkSettingsId ({ commit }, region_park_settings_id) {
    commit('SET_CURRENT_REGION_PARK_SETTINGS_ID', region_park_settings_id)
  },

  changeDialogVisible ({ commit }, { dialogName, value }) {
    commit('CHANGE_DIALOG_VISIBLE', {
      dialogName,
      value
    })
  },
  openCarDialog ({ commit }, data) {
    commit('SET_DATA_CAR_DIALOG', data)
    commit('SET_VISIBLE_CAR_DIALOG', true)
  },
  closeCarDialog ({ commit }, data) {
    commit('SET_DATA_CAR_DIALOG', {})
    commit('SET_VISIBLE_CAR_DIALOG', false)
  },
  setCurrentDriver ({ commit }, driver) {
    commit('SET_CURRENT_DRIVER', driver)
  },

  setCurrentDriverInfo ({ commit }, info) {
    commit('SET_CURRENT_DRIVER_INFO', info)
  },

  setCurrentSchedule ({ commit }, schedule) {
    commit('SET_CURRENT_SCHEDULE', schedule)
  },
  setIgnoringDriverWorking ({ commit, state }, data) {
    if (
      state?.ignoringDriverWorking.filter(
        (driver) => driver.driverId === data?.driverId
      )?.length > 0
    ) {
      return Message({
        message: 'Водитель уже добавлен в список игнорирумеых!',
        type: 'error',
        duration: 5 * 1000
      })
    }
    commit('SET_IGNORING_DRIVER_WORKING', data)
    Message({
      message: 'Водитель был добавлен в список игнорируемых!',
      type: 'success',
      duration: 5 * 1000
    })
  },
  changeFilters ({commit}, data) {
    commit('SET_SCHEDULE_FILTERS', data)
  },
  filterSchedule (
    { commit },
    {
      carCallsign,
      carNumber,
      carModel,
      loadSort,
      modelSort,
      dateTime,
      indicators,
      FIO
    }
  ) {
    commit('SET_FILTER', {
      carCallsign,
      carNumber,
      carModel,
      loadSort,
      modelSort,
      dateTime,
      indicators,
      FIO
    })
  },

  filterDriversBySecondName ({ commit }, secondName) {
    commit('SET_DRIVERS_FILTER', secondName)
  },

  setCurrentCar ({ commit }, id) {
    commit('SET_CURRENT_CAR', id)
  },

  async fetchDriversInChange ({ commit }, params) {
    try {
      const responce = await Api.schedule.index.getDriversInChange(params)
      commit(SET_DRIVERS_IN_CHANGE, responce)
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async setWeekend ({ commit }, data) {
    try {
      await Api.schedule.index.changeIsWeekend(data)
      commit('SET_WEEKEND', data)
    } catch (err) {
      return Promise.reject(err)
    }
  },

  async prolongSchedule (_, data) {
    // try {
    await Api.schedule.index.prolongSchedule(data)
    // } catch (err) {
    //   return Promise.reject(err)
    // }
  }
}
